import { ApiResult, HttpClient } from "../http.js";
import { KlsChecklistDto, KlsChecklistItemType, KlsChecklistType, KlsTradeType } from "../types/kls-checklists.js";

export interface KlsChecklistItemPayload {
  id: string;
  question: string;
  type: KlsChecklistItemType;
  required: boolean;
  order: number;
  category?: string | null;
  helpText?: string | null;
}

export interface CreateKlsChecklistPayload {
  type: KlsChecklistType;
  name: string;
  description?: string | null;
  trade: KlsTradeType;
  isActive: boolean;
  items?: KlsChecklistItemPayload[] | null;
  id?: string;
}

export interface UpdateKlsChecklistPayload {
  type: KlsChecklistType;
  name: string;
  description?: string | null;
  trade: KlsTradeType;
  isActive: boolean;
  items?: KlsChecklistItemPayload[] | null;
}

export interface ListKlsChecklistsQuery {
  isActive?: boolean;
}

export class KlsChecklistsApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListKlsChecklistsQuery = {}): Promise<ApiResult<KlsChecklistDto[]>> {
    return this.http.get<KlsChecklistDto[]>("/api/kls-checklists", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<KlsChecklistDto>> {
    return this.http.get<KlsChecklistDto>(`/api/kls-checklists/${encodeURIComponent(id)}`);
  }

  create(payload: CreateKlsChecklistPayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/kls-checklists", { body: payload });
  }

  update(id: string, payload: UpdateKlsChecklistPayload): Promise<ApiResult<KlsChecklistDto>> {
    return this.http.put<KlsChecklistDto>(`/api/kls-checklists/${encodeURIComponent(id)}`, { body: payload });
  }

  remove(id: string): Promise<ApiResult<string>> {
    return this.http.delete<string>(`/api/kls-checklists/${encodeURIComponent(id)}`);
  }
}
